module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "masked"
  }, [_vm._v("Stepenn")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("Web Front End Engineer")]), _vm._v(" "), _c('a', {
    staticClass: "blog",
    attrs: {
      "href": "./archives/",
      "title": "Blog"
    }
  }, [_vm._v("Blogs")])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/stepenn",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-github"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: ""
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: ""
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-zhihu_circle"
  })]), _vm._v(" "), _c('p', [_vm._v("Hosted by "), _c('a', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "href": "https://pages.coding.me"
    }
  }, [_vm._v("Coding Pages")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3f0d93a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 7
// module chunks = 1